import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const layout = (resolve) => require(['@/layout/index.vue'], resolve);
const userLayout = (resolve) => require(['@/userLayout/index.vue'], resolve);
import layoutChildren from './govLayout/layoutChildren.js';
import userLayoutChildren from './userLayout/layoutChildren.js';
import gov from './gov.js';
import user from './user.js';

// 解决路由重复点击报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
}

const routes = [
  ...gov,
  ...user,
  {
    path: '/',
    redirect: '/login/znw'
  },
  {
    path: '/login/:text',
    component: function (resolve) {
      require(['@/pages/login/login'], resolve)
    }
  },
  {
    path: '/zxw',
    component: function (resolve) {
      require(['@/pages/login/zxw'], resolve)
    }
  },
  {
    path: '/dev/login',
    component: function (resolve) {
      require(['@/pages/dev/login'], resolve)
    }
  },
  {
    path: '/full',
    component: function (resolve) {
      require(['@/pages/dev/full'], resolve)
    }
  },
  {
    path: '/brand/trace/:text',
    component: function (resolve) {
      require(['@/pages/dev/brand-trace'], resolve)
    }
  },
  {
    path: '/dev/langshan',
    component: function (resolve) {
      require(['@/pages/dev/langshan'], resolve)
    }
  },
  {
    path: '/dev/video/:text',
    component: function (resolve) {
      require(['@/pages/dev/jk'], resolve)
    }
  },
  {
    path: '/video/:text',
    component: function (resolve) {
      require(['@/pages/dev/video'], resolve)
    }
  },
  {
    path: '/video/:text/:password',
    component: function (resolve) {
      require(['@/pages/dev/video'], resolve)
    }
  },
  {
    path: '/show',
    component: function (resolve) {
      require(['@/pages/dev/data'], resolve)
    }
  },
  {
    path: '/hd',
    component: function (resolve) {
      require(['@/pages/dev/hd'], resolve)
    }
  },
  {
    path: '/dev/space',
    component: function (resolve) {
      require(['@/pages/dev/space'], resolve)
    }
  },
  {
    path: '/zhijiang/map',
    component: function (resolve) {
      require(['@/pages/dev/zhijiang-map'], resolve)
    }
  },
  {
    path: '/dev/map',
    component: function (resolve) {
      require(['@/pages/dev/map'], resolve)
    }
  },
  {
    path: '/brand/list',
    component: function (resolve) {
      require(['@/pages/brand/list'], resolve)
    }
  },
  {
    path: '/is-bind',
    component: function (resolve) {
      require(['@/pages/login/is-bind'], resolve)
    }
  },
  {
    path: '/bind',
    name: '绑定',
    component: function (resolve) {
      require(['@/pages/login/bind'], resolve)
    }
  },
  {
    path: '/gov',
    component: layout,
    children: layoutChildren
  },
  {
    path: '/user',
    component: userLayout,
    children: userLayoutChildren
  },
  {
    path: '*',
    name: '未找到页面',
    redirect: '/404'
  },
]

export default new Router({
  mode: 'history',
  base: '/',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js